import React, { useState, useEffect, useRef, useCallback, useContext } from 'react'
import { priceFormatter } from '../../../helpers/Numbers';
import { TagManager } from '../../../helpers/TagManager';
import axios from 'axios'
import CarContext from '../../context/CarContext'

const LoanCalcTradeIn = () => {

    const reg = useRef();
    const mileage = useRef();
    const email = useRef();
    const phone = useRef();

    const {car, tradeIn, setTradeIn} = useContext(CarContext)
    const [isLoading, setIsLoading] = useState(false)
    const [isValid, setIsValid] = useState(true)

    const storage = useCallback((tradInData = false) => {
        let storage = JSON.parse(window.sessionStorage.getItem('bbTradeIn') ?? '{}');
        if( tradInData === false) {
            return (storage?.registrationNumber || false) ? storage : false
        } else {
            storage = tradInData;
            window.sessionStorage.setItem('bbTradeIn', JSON.stringify(storage));
        }
    },[])

    const phoneTransform = useCallback((phoneValue) => {
        return phoneValue
            .replace(/[\s,-]/g,'') // remove spaces and dashes
            .replace(/^0/, '+46') // replace starting 0 with +46
    },[])

    const resetTradeIn = () => {
        setTradeIn(null)
        storage(null)
    }
    const webhook = async ( {car: tradeInCar, pageCar, regNo, km, email, phone}) => {
        let fancyPrice = priceFormatter(tradeInCar.price.prediction);
        if(tradeInCar.price.prediction === 0) {
            fancyPrice = 'Kan ej värderas';
        }

        // Check if pageCar exists and registrationNumber is a valid non-empty string
        let pageCarRegNumber = '';
        if (pageCar?.registrationNumber?.trim()) {
            pageCarRegNumber = pageCar.registrationNumber;
        }

        const data = {
            registrationNumber: tradeInCar.registrationNumber,
            mileage: Math.round( parseInt(tradeInCar.dataUsed.km) / 10), // Convert km to mile
            condition: 'Bra skick',
            sellingPrice: tradeInCar.price.prediction,
            waykeValue: tradeInCar.price.original_prediction,
            // 'sellingPrice-fancy': priceFormatter(tradeInCar.price.prediction),
            'sellingPrice-fancy': fancyPrice,
            'waykeValue-fancy': priceFormatter(tradeInCar.price.original_prediction),
            email: email,
            phone: phone,
            make: tradeInCar.dataUsed.manufacturer,
            model: tradeInCar.dataUsed.modelSeries,
            modelYear: tradeInCar.dataUsed.modelYear,
            color: tradeInCar.dataUsed.color,
            carAd: 'Ja',
            carAdRegistrationNumber: pageCarRegNumber,
        }
        try {
            const results =  await axios.post('https://hook.eu1.make.com/tw75vj4ioeylmzi2ywryoql6w5nr64yi', data)
            console.log(results);
        } catch(error) {
            console.error({error})
        }
    }

    const predictionAdjustment = (tradeInData) => {

        // save price prediction without deduction
        tradeInData.price.original_prediction = tradeInData.price.prediction

        // assume car is a contender, if any of the following conditions are met, the car is not a contender     
        let contender = true;
        if( tradeInData.dataUsed.manufacturer === 'Tesla' ) {
            // console.log('Tesla');
            contender = false;
        }

        if( tradeInData.dataUsed.enginePower > 480 ) {
            // console.log('Engine power too high');
            contender = false;
        }

        if( tradeInData.dataUsed.fuelType === 'El' && tradeInData.price.prediction > 300000 ) {
            // console.log('Elbil för dyr');
            contender = false;
        }

        if( tradeInData.price.prediction > 500000 ) {
            // console.log('För dyr');
            contender = false;
        }

        const year = new Date().getFullYear();

        if( (year - tradeInData.dataUsed.modelYear) >= 12 ) {
            // console.log('För gammal');
            contender = false;
        }

        if( (year - tradeInData.dataUsed.modelYear) <= 12 && (year - tradeInData.dataUsed.modelYear) >= 10 && tradeInData.dataUsed.mileage > 16000) {
            // console.log('För många mil');
            contender = false;
        }

        if( (year - tradeInData.dataUsed.modelYear) <= 10 && tradeInData.dataUsed.mileage > 20000) {
            // console.log('För många mil');
            contender = false;
        }             
       
        // Calculate deduction
        let subtractPercentage = 1.0;
        let maxDeductable = 9999999;


        if(contender) {
            // console.log('Is Contender');
            if( tradeInData.price.prediction < 400000 ) {
                subtractPercentage = .25
                maxDeductable = 68000
            }
            if( tradeInData.price.prediction >= 400000 ) {
                subtractPercentage = .17                
            }      
        }

        
        let deduct = tradeInData.price.prediction * subtractPercentage;
        // console.log({tradeInData, subtractPercentage, maxDeductable, deduct})

        if( deduct > maxDeductable ) {
            deduct = maxDeductable;
        }

        // set new price prediction and return data
        tradeInData.price.prediction = tradeInData.price.prediction - deduct; 
        return tradeInData;
    }

    const handleSubmit = useCallback( async (e) => {
        e.preventDefault()
        if(isLoading) { return }
        
        reg.current.setCustomValidity('');
        mileage.current.setCustomValidity('');
        email.current.setCustomValidity('');
        phone.current.setCustomValidity('');

        if( !reg.current.checkValidity() || !mileage.current.checkValidity() || !email.current.checkValidity() || !phone.current.checkValidity() ) {
        
            if(!reg.current.checkValidity() ) {
                reg.current.setCustomValidity('Ex ABC123 eller ABC12D');
                reg.current.reportValidity()
            } 

            else if(!mileage.current.validity.valid ) {
                mileage.current.setCustomValidity('0-999999, inga mellanrum bara siffror');
                mileage.current.reportValidity()
            } 

            else if(!email.current.validity.valid ) {
                email.current.setCustomValidity('En giltig e-post adress, ex. fornamn.efternamn@foretag.se');
                email.current.reportValidity()
            }
            
            else if(!phone.current.validity.valid ) {
                email.current.setCustomValidity('En giltig e-post adress, ex. fornamn.efternamn@foretag.se');
                email.current.reportValidity()
            }

            setIsValid(false);
            console.dir( {validity:reg.current.validity, value: reg.current.value } );
            console.dir( {validity:mileage.current.validity, value: mileage.current.value } );
            console.dir( {validity:email.current.validity, value: email.current.value } );
            console.dir( {validity:phone.current.validity, value: phone.current.value } );
            return false;

        }

        setIsLoading(true)
        setIsValid(true);
        const config = {
            headers: {
                'Accept': 'application/json'
            },
            params: {
                regNo: reg.current.value,
                km: parseInt(mileage.current.value) * 10,
                email: email.current.value,
                phone: phoneTransform(phone.current.value)
            }
        }
        const url = `${process.env.REACT_APP_WAYKE_API_URL}/tradein`
        try {
            const results = await axios.get(url, config)
            const dataAdjusted = predictionAdjustment(results.data)

            webhook( { car: dataAdjusted, pageCar: car, ...config.params } );
            storage(dataAdjusted)
            setTradeIn(dataAdjusted)
            TagManager({event: 'TradeIn'})
            setIsLoading(false)
        } catch {
            setIsLoading(false)
            alert('Tyvärr gick något fel, vänligen försök igen senare')
            return;
        }

    },[car])

    useEffect(()=>{
        console.log('Setting tradeIn from storage')
        setTradeIn(storage(false))
        console.dir(storage(false))
    },[])

    const tradeInForm = () =>{
        return (
            <>
                <div className="trade-in">  
                    <div className="label">
                        <h4>Inbytesbil?</h4>  
                        <small>Fyll i uppgifterna så får du en preliminär värdering</small>
                    </div>
                    <div className="form-wrapper">
                        <div className="form">
                            <input 
                                type="text" 
                                ref={reg}
                                name="reg"
                                className="regno"
                                pattern="[a-zA-Z]{3}([0-9]{2}[a-zA-Z]{1}|[0-9]{3})"
                                required
                                disabled={isLoading}
                                title="Registreringsnummer (abc123)"
                                size="6"
                                placeholder="Regnr." />
                            <input 
                                type="text" 
                                ref={mileage}
                                name="mileage" 
                                id="mileage" 
                                pattern="[0-9]{1,}"
                                disabled={isLoading}
                                size="5"
                                min="1"
                                required
                                placeholder="Miltal" />

                            <input 
                                type="email" 
                                ref={email}
                                name="email" 
                                id="email"
                                className='fullwidth-mobile'
                                pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
                                disabled={isLoading}
                                required
                                placeholder="Epostadress" />

                            <input 
                                type="tel" 
                                ref={phone}
                                name="phone" 
                                id="phone"
                                className='fullwidth-mobile'
                                pattern="((\+[1-9]{2,4})|0)([0-9]{1,4})([\s-]+)?([0-9]{2,4})([\s-]+)?([0-9]{2,4})([\s-]+)?([0-9]{2,4})"
                                disabled={isLoading}
                                required
                                placeholder="Telefonnummer" />
            
                            <button 
                                className="text-block white small"
                                disabled={isLoading}
                                onClick={handleSubmit}>Hämta&nbsp;värdering
                            </button>
                        </div>       
                        { !isValid &&
                            <span className="invalid">Ett eller flera fält är inte rätt ifyllda.</span>
                        }
                    </div>             
                </div>

            </>
        )
    }

    const tradeInData = () => {        
        let valuationMsg = 'Värde ca: ' + priceFormatter(tradeIn.price.prediction, ':-');

        if(tradeIn.price.prediction === 0) {
            valuationMsg = 'Går ej att värdera online';
        }        

        return (
            <>
                <div className="trade-in">
                    <div className="label">
                        <h4>{`${tradeIn.dataUsed.manufacturer} ${tradeIn.dataUsed.modelSeries} ${tradeIn.dataUsed.modelYear}`}</h4>
                        <small>{`${ Math.floor(parseInt(tradeIn.dataUsed.km) / 10) } mil.`} </small>
                        <small>Räknat på att bilen är i bra skick. Detta är en preliminär onlinevärdering.
                        Vill du gå vidare kommer vi göra en professionell värdering manuellt.</small>
                    </div>
                    <div className="data">                        
                        <h3 className="text-block small grey mr-1">{valuationMsg}</h3>
                        <button onClick={resetTradeIn} className="text-block small white">Börja om</button>
                    </div>
                </div>
            </>
        )
    }

    const loadingAnimation = () => {
        return (
            <div className="trade-in">
                <div className="container loading small">

                </div>
            </div>
        )
    }


    return isLoading ? loadingAnimation() : (tradeIn ? tradeInData() : tradeInForm())
}

export default LoanCalcTradeIn;